var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirectUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/messages-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messages-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.4785 35.0626L39.291 41.6458C39.4994 43.375 37.6452 44.5833 36.166 43.6875L27.4369 38.5C26.4785 38.5 25.541 38.4375 24.6244 38.3125C26.166 36.5 27.0827 34.2083 27.0827 31.7291C27.0827 25.8125 21.9577 21.0209 15.6244 21.0209C13.2077 21.0209 10.9785 21.7084 9.12437 22.9167C9.06187 22.3959 9.04102 21.875 9.04102 21.3333C9.04102 11.8542 17.2702 4.16669 27.4369 4.16669C37.6035 4.16669 45.8327 11.8542 45.8327 21.3333C45.8327 26.9583 42.9369 31.9376 38.4785 35.0626Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.0827 31.7291C27.0827 34.2083 26.166 36.5 24.6244 38.3125C22.5619 40.8125 19.291 42.4166 15.6243 42.4166L10.1868 45.6458C9.27018 46.2083 8.10351 45.4375 8.22851 44.375L8.74934 40.2709C5.95768 38.3334 4.16602 35.2291 4.16602 31.7291C4.16602 28.0624 6.12436 24.8333 9.12436 22.9167C10.9785 21.7083 13.2077 21.0209 15.6243 21.0209C21.9577 21.0209 27.0827 25.8124 27.0827 31.7291Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectUp);
export default __webpack_public_path__ + "static/media/direct-up.3cba382e73e46b3e590f969fee63a455.svg";
export { ForwardRef as ReactComponent };